import React from "react";
import ExperienceCard from "./ExperienceCard";

const Experience = () => {
  return (
    <div id='experience' className='mt-4 text-white'>
      <h1 className='text-2xl font-bold'>Experience</h1>
      <p className='font-light text-gray-400'>Here are some of my Experience</p>

      <div className='flex flex-col md:flex-row mt-4 gap-5'>
        <ExperienceCard
          name='Web Development'
          issued='Feb 2023 - Present'
          desc='Working on a personal project where gamers of different platform can
          share their experience, report bugs, request solutions to problems. There
          will be other features like commenting on post and lots more. (MERN)
          '
        />
        <ExperienceCard
          name='Brac University - Student Tutor'
          issued='Jan 2022 - Present'
          desc='CSE220 | Data Structures (Spring, 2022), 
          CSE110 | Programming Language I (Summer 2022 - Present)'
        />
      </div>
    </div>
  );
};

export default Experience;
